import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

const LABEL_KEY_RE = /^[a-zA-Z_][a-zA-Z0-9_]*$/;

const labelsValidator = Yup.string()
  .label("Labels")
  .test("valid-labels", "Each label must be in key=value format with a valid key.", (value) => {
    if (!value) return true;
    const parts = value
      .split(/[,\n\r]+/)
      .map((p) => p.trim())
      .filter(Boolean);
    return parts.every((part) => {
      const eq = part.indexOf("=");
      if (eq <= 0 || eq === part.length - 1) return false;
      const key = part.slice(0, eq);
      const val = part.slice(eq + 1);
      return LABEL_KEY_RE.test(key) && val.length > 0;
    });
  });

export const GrafanaPrometheusShape = {
  prometheus_url: Yup.string()
    .label("Prometheus Remote Write URL")
    .url()
    .required()
    .test(
      "ends-with-push",
      "Please ensure the URL entered above has '/push' an the end of the Grafana supplied URL.",
      (value) => !value || value.replace(/\/+$/, "").endsWith("/push")
    ),
  metrics_instance_id: Yup.string().label("Metrics Instance ID").required(),
  metrics_api_token: Yup.string().label("Metrics API Token").required(),
  tags: labelsValidator,
};

export interface GrafanaPrometheusInput {
  prometheus_url: string;
  metrics_instance_id: string;
  metrics_api_token: string;
  tags?: string;
}

export const GrafanaPrometheusDefaults = {tags: ""};

yupResolver<GrafanaPrometheusInput>(Yup.object().shape(GrafanaPrometheusShape));
